(ns ui.components.calculi-tree.formatted-view
  (:require [clojure.string :as string]
            [common.util :as cu]))

(def operator-symbols
  {:calculi-type/operator-sum            "+"
   :calculi-type/operator-subtraction    "-"
   :calculi-type/operator-multiplication "*"
   :calculi-type/operator-division       "/"
   :calculi-type/parenthesis-group       nil})

(defn format-expression
  [node field-labels]
  (let [{:keys [calculi-type rules field]} node]
    (case calculi-type
      :calculi-type/field
      (get field-labels field (str field))

      :calculi-type/constant
      (str (:value node))

      :calculi-type/parenthesis-group
      (str "("
           (string/join " " (map #(format-expression % field-labels) rules))
           ")")

      :calculi-type/operator-subtraction
      (let [symbol "-"
            children (map #(format-expression % field-labels) rules)]
        (case (count children)
          1 (str "(" symbol " " (first children) ")") ; unary minus
          2 (str "(" (first children) " " symbol " " (second children) ")")
          ;; fallback for weird cases
          (str "(" (string/join (str " " symbol " ") children) ")")))

      (:calculi-type/operator-sum
        :calculi-type/operator-multiplication
        :calculi-type/operator-division)
      (let [symbol (get operator-symbols calculi-type)]
        (->> rules
             (map #(format-expression % field-labels))
             (string/join (str " " symbol " "))
             (cu/format "(%s)")))

      ;; fallback
      "?")))
